/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  GetEmailTypesPathParameters,
  IterableEmailSenderDetailRequest,
  IterableEmailTypeDTO,
  IterableEmailTypeDefaultRequest,
  UpdateEmailTypePathParameters,
  UpdateSenderDetailsPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getIterableEmailType = () => {
  /**
 * Update client's email type

Required authority: PERM_CLIENT_WRITE
 */
  const updateEmailType = (
    { clientId, emailTypeId }: UpdateEmailTypePathParameters,
    iterableEmailTypeDefaultRequest: IterableEmailTypeDefaultRequest,
  ) => {
    return customInstance<IterableEmailTypeDTO>({
      url: `/api/clients/${clientId}/email-types/${emailTypeId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: iterableEmailTypeDefaultRequest,
    });
  };
  /**
 * Update client's email type sender details

Required authority: PERM_CLIENT_WRITE
 */
  const updateSenderDetails = (
    { clientId, emailTypeId }: UpdateSenderDetailsPathParameters,
    iterableEmailSenderDetailRequest: IterableEmailSenderDetailRequest[],
  ) => {
    return customInstance<IterableEmailTypeDTO>({
      url: `/api/clients/${clientId}/email-types/${emailTypeId}/sender-details`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: iterableEmailSenderDetailRequest,
    });
  };
  /**
 * Get client's email types

Required authority: PERM_TOUCHPOINT_READ
 */
  const getEmailTypes = ({ clientId }: GetEmailTypesPathParameters) => {
    return customInstance<IterableEmailTypeDTO[]>({
      url: `/api/clients/${clientId}/email-types`,
      method: "GET",
    });
  };
  return { updateEmailType, updateSenderDetails, getEmailTypes };
};
export type UpdateEmailTypeResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getIterableEmailType>["updateEmailType"]>>
>;
export type UpdateSenderDetailsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getIterableEmailType>["updateSenderDetails"]>>
>;
export type GetEmailTypesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getIterableEmailType>["getEmailTypes"]>>
>;
